import * as React from 'react'

import formatPrice from '../../../../common/utils/formatPrice'

import * as styles from './lockupPrice.module.css'

const LockupPrice = ({ priceInCents }: { priceInCents: number }) => {
  return <div className={styles.root}>${formatPrice(priceInCents)}</div>
}

export default LockupPrice
